import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { B as Box } from "./Grid-CcQKdsgp.js";
const styleTransformer = (value) => {
  return typeof value === "string" ? value : `${value}px`;
};
const justifyStyle = (value, breakpoint) => {
  if (!value) return "";
  const justifyClass = {
    center: breakpoint === "md" ? "md:justify-center" : breakpoint === "lg" ? "lg:justify-center" : "justify-center",
    end: breakpoint === "md" ? "md:justify-end" : breakpoint === "lg" ? "lg:justify-end" : "justify-end",
    "flex-end": breakpoint === "md" ? "md:justify-end" : breakpoint === "lg" ? "lg:justify-end" : "justify-end",
    "flex-start": breakpoint === "md" ? "md:justify-start" : breakpoint === "lg" ? "lg:justify-start" : "justify-start",
    start: breakpoint === "md" ? "md:justify-start" : breakpoint === "lg" ? "lg:justify-start" : "justify-start",
    "space-around": breakpoint === "md" ? "md:justify-around" : breakpoint === "lg" ? "lg:justify-around" : "justify-around",
    "space-between": breakpoint === "md" ? "md:justify-between" : breakpoint === "lg" ? "lg:justify-between" : "justify-between",
    "space-evenly": breakpoint === "md" ? "md:justify-evenly" : breakpoint === "lg" ? "lg:justify-evenly" : "justify-evenly",
    stretch: breakpoint === "md" ? "md:justify-stretch" : breakpoint === "lg" ? "lg:justify-stretch" : "justify-stretch",
    baseline: breakpoint === "md" ? "md:justify-baseline" : breakpoint === "lg" ? "lg:justify-baseline" : "justify-baseline",
    normal: breakpoint === "md" ? "md:justify-normal" : breakpoint === "lg" ? "lg:justify-normal" : "justify-normal"
  };
  return justifyClass[value];
};
const flexWrapStyle = (value, breakpoint) => {
  if (!value) return "";
  const flexWrapClass = {
    wrap: breakpoint === "md" ? "md:flex-wrap" : breakpoint === "lg" ? "lg:flex-wrap" : "flex-wrap",
    nowrap: breakpoint === "md" ? "md:flex-nowrap" : breakpoint === "lg" ? "lg:flex-nowrap" : "flex-nowrap",
    "wrap-reverse": breakpoint === "md" ? "md:flex-wrap-reverse" : breakpoint === "lg" ? "lg:flex-wrap-reverse" : "flex-wrap-reverse"
  };
  return flexWrapClass[value];
};
const directionStyle = (value, breakpoint) => {
  if (!value) return "";
  const directionClass = {
    column: breakpoint === "md" ? "md:flex-col" : breakpoint === "lg" ? "lg:flex-col" : "flex-col",
    "column-reverse": breakpoint === "md" ? "md:flex-col-reverse" : breakpoint === "lg" ? "lg:flex-col-reverse" : "flex-col-reverse",
    row: breakpoint === "md" ? "md:flex-row" : breakpoint === "lg" ? "lg:flex-row" : "flex-row",
    "row-reverse": breakpoint === "md" ? "md:flex-row-reverse" : breakpoint === "lg" ? "lg:flex-row-reverse" : "flex-row-reverse"
  };
  return directionClass[value];
};
const alignStyle = (value, breakpoint) => {
  if (!value) return "";
  const alignClass = {
    center: breakpoint === "md" ? "md:items-center" : breakpoint === "lg" ? "lg:items-center" : "items-center",
    start: breakpoint === "md" ? "md:items-start" : breakpoint === "lg" ? "lg:items-start" : "items-start",
    end: breakpoint === "md" ? "md:items-end" : breakpoint === "lg" ? "lg:items-end" : "items-end",
    "flex-start": breakpoint === "md" ? "md:items-start" : breakpoint === "lg" ? "lg:items-start" : "items-start",
    "flex-end": breakpoint === "md" ? "md:items-end" : breakpoint === "lg" ? "lg:items-end" : "items-end",
    stretch: breakpoint === "md" ? "md:items-stretch" : breakpoint === "lg" ? "lg:items-stretch" : "items-stretch",
    baseline: breakpoint === "md" ? "md:items-baseline" : breakpoint === "lg" ? "lg:items-baseline" : "items-baseline"
  };
  return alignClass[value];
};
const useFlex = (params) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const styles = {};
  let className = "";
  if (typeof params.m.gap !== "undefined") {
    styles["--gap"] = styleTransformer(params.m.gap);
    className += "gap-[var(--gap)] ";
  }
  const mdGap = (_a = params.md.gap) != null ? _a : params.m.gap;
  if (typeof params.md.gap !== "undefined" && params.md.gap !== params.m.gap) {
    styles["--md-gap"] = styleTransformer(params.md.gap);
    className += "md:gap-[var(--md-gap)] ";
  }
  if (typeof params.d.gap !== "undefined" && params.d.gap !== mdGap) {
    styles["--d-gap"] = styleTransformer(params.d.gap);
    className += "lg:gap-[var(--d-gap)] ";
  }
  if (params.m.justify) {
    className += justifyStyle(params.m.justify) + " ";
  }
  const mdJustify = (_b = params.md.justify) != null ? _b : params.m.justify;
  if (params.md.justify && params.md.justify !== params.m.justify) {
    className += justifyStyle(params.md.justify, "md") + " ";
  }
  if (params.d.justify && params.d.justify !== mdJustify) {
    className += justifyStyle(params.d.justify, "lg") + " ";
  }
  if (params.m.flexWrap) {
    className += flexWrapStyle(params.m.flexWrap) + " ";
  }
  if (params.md.flexWrap && params.md.flexWrap !== params.m.flexWrap) {
    className += flexWrapStyle(params.md.flexWrap, "md") + " ";
  }
  const mdFlexWrap = (_c = params.md.flexWrap) != null ? _c : params.m.flexWrap;
  if (params.d.flexWrap && params.d.flexWrap !== mdFlexWrap) {
    className += flexWrapStyle(params.d.flexWrap, "lg") + " ";
  }
  if (params.m.align) {
    className += alignStyle(params.m.align) + " ";
  }
  if (params.md.align && params.md.align !== params.m.align) {
    className += alignStyle(params.md.align, "md") + " ";
  }
  const mdAlign = (_d = params.md.align) != null ? _d : params.m.align;
  if (params.d.align && params.d.align !== mdAlign) {
    className += alignStyle(params.d.align, "lg") + " ";
  }
  if (params.m.flexDirection) {
    className += directionStyle(params.m.flexDirection) + " ";
  }
  if (params.md.flexDirection && params.md.flexDirection !== params.m.flexDirection) {
    className += directionStyle(params.md.flexDirection, "md") + " ";
  }
  const mdDirection = (_e = params.md.flexDirection) != null ? _e : params.m.flexDirection;
  if (params.d.flexDirection && params.d.flexDirection !== mdDirection) {
    className += directionStyle(params.d.flexDirection, "lg") + " ";
  }
  if (params.m.order !== void 0) {
    styles["--o"] = params.m.order;
    className += `order-[var(--o)] `;
  }
  if (params.md.order !== void 0 && params.md.order !== params.m.order) {
    styles["--md-o"] = params.md.order;
    className += `md:order-[var(--md-o)] `;
  }
  const mdOrder = (_f = params.md.order) != null ? _f : params.m.order;
  if (params.d.order !== void 0 && params.d.order !== mdOrder) {
    styles["--lg-o"] = params.d.order;
    className += `lg:order-[var(--lg-o)] `;
  }
  if (params.m.shrink !== void 0) {
    styles["--shrink"] = params.m.shrink;
    className += `shrink-[var(--shrink)] `;
  }
  if (params.md.shrink !== void 0 && params.md.shrink !== params.m.shrink) {
    styles["--md-shrink"] = params.md.shrink;
    className += `md:shrink-[var(--md-shrink)] `;
  }
  const mdShrink = (_g = params.md.shrink) != null ? _g : params.m.shrink;
  if (params.d.shrink !== void 0 && params.d.shrink !== mdShrink) {
    styles["--lg-shrink"] = params.d.shrink;
    className += `lg:shrink-[var(--lg-shrink)] `;
  }
  if (params.m.grow !== void 0) {
    styles["--grow"] = params.m.grow;
    className += `grow-[var(--grow)] `;
  }
  if (params.md.grow !== void 0 && params.md.grow !== params.m.grow) {
    styles["--md-grow"] = params.md.grow;
    className += `md:grow-[var(--md-grow)] `;
  }
  const mdGrow = (_h = params.md.grow) != null ? _h : params.m.grow;
  if (params.d.grow !== void 0 && params.d.grow !== mdGrow) {
    styles["--lg-grow"] = params.d.grow;
    className += `lg:grow-[var(--lg-grow)] `;
  }
  return {
    styles,
    className
  };
};
const Flex = forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props, ref) => {
    const {
      md,
      d,
      className,
      children,
      display = "flex",
      flexDirection,
      flexWrap,
      gap,
      align,
      justify,
      style,
      order,
      shrink,
      grow
    } = props;
    const flex = useFlex({
      m: { flexWrap, gap, align, flexDirection, justify, order, shrink, grow },
      md: { ...md },
      d: { ...d }
    });
    return /* @__PURE__ */ jsx(
      Box,
      {
        ...props,
        display,
        ref,
        className: `${className != null ? className : ""} ${flex.className}`,
        style: {
          ...flex.styles,
          ...style
        },
        children
      }
    );
  }
);
export {
  Flex as F
};
